import { ApiRoutes } from "../../../../../constants/api";
import { BaseAPI, RequestMethod } from "../../../base";
import { FeatureDeleteRequestBody, FeatureDeleteResponse } from "./types";

export class FeatureDeleteAPI extends BaseAPI<
    FeatureDeleteRequestBody,
    FeatureDeleteResponse
> {
    protected route = ApiRoutes.feature.delete;
    protected method = RequestMethod.DELETE;
    protected params = ['id'];
}
